import type { TFunction } from 'i18next';

/**
 * Picks the empty-state message shared by Katalog nośników and Mapa
 * (CU-86cbenzvw — the "Map filter controls with table parity" requirement in
 * `interactive-map` extends parity to the zero-results state).
 *
 * Priority:
 * 1. When the catalog is scoped to a specific import job (`importJobId` present) and the query
 *    returns no rows, the user needs to know the import batch itself has no matching media
 *    units — not that their filters are too narrow, and not any permission caveat.
 * 2. Otherwise, when the caller's own permissions genuinely narrow what they can see
 *    (`isPermissionNarrowed`), the message additionally suggests a permission scope as a
 *    POSSIBLE cause — never a certain one, and never naming the specific permission,
 *    supplier, or media type withheld, since the server narrows results per row and does
 *    not distinguish "nothing matched" from "rows were filtered by scope".
 * 3. Otherwise the plain generic empty state.
 */
export function resolveEmptyMessage(
  importJobId: number | undefined,
  isPermissionNarrowed: boolean,
  t: TFunction<'inventory'>,
): string {
  if (importJobId != null) return t('emptyStateImportJob');
  if (isPermissionNarrowed) return t('emptyStatePermissionScope');
  return t('emptyState');
}
